import { useTranslations } from "use-intl";
import { ErrorPageShell } from "./error-page-shell";
import { ErrorContent } from "./error-content";

export function NotFoundPage() {
  const t = useTranslations();

  return (
    <ErrorPageShell page="404">
      <ErrorContent
        code={t("errors.404.code")}
        title={t("errors.404.title")}
        description={t("errors.404.desc")}
      />
    </ErrorPageShell>
  );
}
